import { render, staticRenderFns } from "./inverter.vue?vue&type=template&id=2671099d&scoped=true&"
var script = {}
import style0 from "./inverter.vue?vue&type=style&index=0&id=2671099d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2671099d",
  null
  
)

export default component.exports